let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cGSfe"), load("8E4u5"), load("jigcs"), load("4LmEY")]).then(() => parcelRequire('heHIK'));